<template>
  <div class="wrapper-landing">
    <LandingHero
      title="Créez votre liste de naissance en ligne gratuitement"
      subtitle="Réunissez vos coups de cœur de naissance et partagez-les avec ceux qui vous sont chers."
      origin="listabebe"
      lang="fr-FR"
      buttonText="Créer ma liste gratuitement"
    >
      <template v-slot:cover>
        <source
          media="(max-width: 991px)"
          class=""
          srcset="../../assets/img/landings/cover-mujer-joven-embarazada-movil-resp.jpg"
          alt=""
          loading="lazy"
        />
        <img
          class="ln-hero__inset"
          src="../../assets/img/landings/cover-mujer-joven-embarazada-movil.jpg"
          alt=""
          loading="lazy"
        />
      </template>
    </LandingHero>
    <main class="bg-cercles">
      <LandingAppRatings />

      <section class="bb-container">
        <LandingFeaturesSimple title="HelloBB est fait pour vous si :"
        :use-carousel="false"
        >
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-embarazada.svg" alt="" />
            </template>
            <template slot="title">
              C'est votre premier bébé et vous ne savez pas par où commencer.
            </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-q.svg" alt="" />
            </template>
            <template slot="title">
              Vos proches veulent savoir ce dont bébé a besoin pour son arrivée.
            </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-mobile-cart.svg" alt="" />
            </template>
            <template slot="title"> Vous souhaitez piocher dans plusieurs enseignes. </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-hand-heart.svg" alt="" />
            </template>
            <template slot="title">
              Vous voulez une solution fluide et esthétique pour partager vos coups de cœur.
            </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-clipboard.svg" alt="" />
            </template>
            <template slot="title">
              Vous voulez tout planifier pour accueillir bébé en toute sérénité.
            </template>
          </LandingFeaturesSimpleItem>
        </LandingFeaturesSimple>
      </section>
    </main>

    <LandingFeaturesCover title="Une liste de naissance ultra-complète">
      <LandingFeaturesCoverItem>
        <template slot="cover">
          <img src="../../assets/img/landings/cover-retailers-box-fr.png" alt="" />
        </template>
        <template slot="titulo">
          Ajoutez n’importe quel modèle, marque ou boutique.
        </template>

        <template slot="descripcion">
          <p>
            Un simple copier-coller pour remplir votre liste
          </p>
        </template>
      </LandingFeaturesCoverItem>
      <LandingFeaturesCoverItem>
        <template slot="cover">
          <img src="../../assets/img/covers/cover-regalos-efectivo.svg" alt="" />
        </template>
        <template slot="titulo"> Cagnottes : collectez des fonds avec 0 % de commission </template>

        <template slot="descripcion">
          <p>
            Laissez vos proches choisir entre un cadeau physique ou une participation à votre cagnotte. Profitez d'un service 100 % gratuit y recevez l'intégralité des sommes versées.
          </p>
        </template>
      </LandingFeaturesCoverItem>
      <!-- <LandingFeaturesCoverItem>
        <template slot="cover">
          <img src="../../assets/img/covers/mockup-aportacions.png" alt="" />
        </template>
        <template slot="titulo"> Offrez la possibilité de se cotiser pour les achats les plus chers </template>

        <template slot="descripcion">
          <p>
              Votre famille et vos amis pourront faire des contributions partielles pour acheter à plusieurs les produits les plus chers.
          </p>
        </template>
      </LandingFeaturesCoverItem> -->
      <FeaturesCoverItemListUpdate lang="fr-FR" />
    </LandingFeaturesCover>

    <main class="bg-cercles">
      <section class="bb-container">
        <LandingReviewsWedding lang="fr-FR" />
      </section>
    </main>

    <LandingComoCols title="Comment ça marche ?" subtitle="Votre liste de naissance en ligne.">
      <LandingComoColsItem>
        <template slot="icono">
          <img src="../../assets/img/ico/ico-max-click.svg" alt="" />
        </template>
        <template slot="titulo">Sélectionnez vos coups de cœur</template>
        <template slot="descripcion">
          <p>
            Piochez vos articles préférés dans n'importe quelle boutique en ligne. Un simple copier-coller du lien suffit pour les ajouter à votre liste.
          </p>
          <p>
              Créez aussi des cagnottes pour financer tous vos projets.
          </p>
        </template>
      </LandingComoColsItem>
      <LandingComoColsItem>
        <template slot="icono">
          <img src="../../assets/img/ico/ico-max-share.svg" alt="" />
        </template>
        <template slot="titulo">Partagez vos envies</template>
        <template slot="descripcion">
          <p>Dès que vous le souhaitez, envoyez votre liste à vos proches.</p>
          <p>
             Un simple lien suffit pour leur faire découvrir votre univers. Accessible sur mobile, tablette ou PC, et sans aucune inscription requise.
          </p>
        </template>
      </LandingComoColsItem>
      <LandingComoColsItem>
        <template slot="icono">
          <img src="../../assets/img/ico/ico-max-gift.svg" alt="" />
        </template>
        <template slot="titulo">Recevez vos cadeaux</template>
        <template slot="descripcion">
          <p>
            Vos proches pourront choisir le cadeau de naissance qu’ils préfèrent dans votre liste et l’acheter. Ils pourront vous l’envoyer directement ou le garder pour vous l’offrir lors d’une visite.
          </p>
          <p>
            Pour éviter les doublons, ils pourront indiquer que l’article a déjà été offert.
          </p>
        </template>
      </LandingComoColsItem>
    </LandingComoCols>

    <LandingFooter lang="fr-FR" />
  </div>
</template>

<script>
import LandingFeaturesSlider from "./components/LandingFeaturesSlider.vue";

import LandingFeaturesSimple from "./components/LandingFeaturesSimple.vue";
import LandingFeaturesSimpleItem from "./components/LandingFeaturesSimpleItem.vue";

import LandingHero from "./components/LandingHero.vue";
import LandingAppRatings from "./components/LandingAppRatings.vue";
import LandingFeaturesCover from "./components/LandingFeaturesCover";
import LandingFeaturesCoverItem from "./components/LandingFeaturesCoverItem";
import LandingReviews from "./components/LandingReviews.vue";
import LandingHablan from "./components/LandingHablan.vue";
import LandingReviewsWedding from "./components/LandingReviewsWedding.vue";
import LandingFooter from "./components/LandingFooter.vue";

import LandingComoCards from "./components/LandingComoCards.vue";
import LandingComoCardsItem from "./components/LandingComoCardsItem.vue";
import LandingComoColsItem from "./components/LandingComoColsItem.vue";
import LandingComoCols from "./components/LandingComoCols.vue";

import FeaturesCoverItemListUpdate from "./components/FeaturesCoverItemListUpdate.vue";

// import bbButton from "../../components/buttons/bbButton.vue";

export default {
  name: "LandingNoListFR",
  metaInfo() {
    return {
      title: "HelloBB : la liste de naissance universelle et 100 % libre",
      htmlAttrs: {
        lang: "fr",
      },
      meta: [
        { name: "description", content: "HelloBB est la liste de naissance en ligne où toutes vos envies prennent vie." },
        { name: "robots", content: "noindex" },
      ],
    };
  },
  components: {
    LandingComoCols,
    LandingComoColsItem,
    LandingAppRatings,
    LandingHablan,
    LandingReviews,
    LandingFooter,
    LandingHero,
    LandingFeaturesCover,
    LandingFeaturesCoverItem,
    LandingFeaturesSlider,
    LandingFeaturesSimple,
    LandingFeaturesSimpleItem,
    LandingComoCards,
    LandingComoCardsItem,
    LandingReviewsWedding,
    FeaturesCoverItemListUpdate,
  },
};
</script>

<style lang="scss" scoped></style>
